import React, { useEffect } from "react";
import WOW from "wowjs";

function Journey() {

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <section id="journey" className="flow-main-section pt-100 pb-100">

      <div className="container">

        {/* TITLE */}
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 text-center">

            <div className="section-title mb-60">

              <h3
                className="mb-20 wow fadeInUp"
                data-wow-delay=".2s"
              >
                Our 6-Step Learning Journey
              </h3>

              <p
                className="wow fadeInUp"
                data-wow-delay=".4s"
              >
                A structured path from assessment to mentorship,
                guiding students step by step.
              </p>

            </div>

          </div>
        </div>

        {/* STEPS */}
        <div className="designer-box">

          <div className="row">

            {/* STEP 1 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="step-circle">1</div>

                <h3>Book a Phone Call</h3>

                <p>
                  A phone call with our advisor to understand
                  specific requirements.
                </p>
              </div>
            </div>

            {/* STEP 2 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".4s"
              >
                <div className="step-circle">2</div>

                <h3>Diagnostic Test</h3>

                <p>
                  Assess the primary skill set in order to better
                  guide the student towards the desired score.
                </p>
              </div>
            </div>

            {/* STEP 3 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".6s"
              >
                <div className="step-circle">3</div>

                <h3>Consultation Meeting</h3>

                <p>
                  Assessment of performance in diagnostic tests
                  to customize and create the program.
                </p>
              </div>
            </div>

            {/* STEP 4 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="step-circle">4</div>

                <h3>1 on 1 Live Tutoring</h3>

                <p>
                  At your own convenience, anywhere in the world.
                  Comprehensive prep materials provided.
                </p>
              </div>
            </div>

            {/* STEP 5 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".4s"
              >
                <div className="step-circle">5</div>

                <h3>Dedicated Mentor</h3>

                <p>
                  Keeps track of progress continuously,
                  sets deadlines, and raises a flag where needed.
                </p>
              </div>
            </div>

            {/* STEP 6 */}
            <div className="col-lg-4 col-md-6">
              <div
                className="flow-step wow fadeInUp"
                data-wow-delay=".6s"
              >
                <div className="step-circle">6</div>

                <h3>Practice Tests</h3>

                <p>
                  Sectional & full tests with review sessions
                  to pinpoint pain points and suggest remedies.
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default Journey;